import { DSIcon } from '../../../../base';

import styles from './GracePeriodIcon.module.scss';

const GracePeriodCancellationIcon = () => (
  <span className={styles['grace-period-icon']}>
    <DSIcon name="history" />
  </span>
);

export default GracePeriodCancellationIcon;
